export default function Footer() {
  return (
    <footer
      className="footer"
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "500px",
        padding: "20px",
      }}
    >
      {/* TOP – Map */}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginBottom: "auto",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "900px",   // ⬅️ bigger width
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 6px 20px rgba(0,0,0,0.35)",
          }}
        >
          <iframe
          title="Revived Hair Co Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d198961.79102830283!2d-77.49090090546875!3d38.814640100000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b39a8e334fc7%3A0x116bd1eb6fcd37f9!2sRevived%20Hair%20Co.!5e0!3m2!1sen!2sus!4v1778526481698!5m2!1sen!2sus"
            width="100%"
            height="420px"   // ⬅️ bigger height
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      {/* BOTTOM – Copyright */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        &copy; 2026 Revived Hair Co. All rights reserved.
      </div>
    </footer>
  );
}